import { useState } from "react";
import api from "src/common/axiosInstance";
import { clearLeads } from "../../CachedData";
import { DocumentDialog, DocumentError, buttonClass } from "../../Documents/DocumentUI";

export default function DeleteLeadsDialog({ leadIds, leadName, workspaceId, onClose, onDeleted }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const count = leadIds.length;
  const remove = async () => {
    if (busy) return;
    setBusy(true); setError("");
    try {
      const config = { headers: { "X-Workspace-ID": workspaceId } };
      if (count === 1) await api.delete(`/leads/${leadIds[0]}`, config);
      else await api.post("/leads/bulk-delete", { lead_ids: leadIds }, config);
    } catch (err) {
      setError(err?.response?.data?.message || "Unable to delete the leads. Refresh before retrying.");
      setBusy(false); return;
    }
    clearLeads();
    onDeleted();
  };
  return <DocumentDialog title={count === 1 ? "Delete lead?" : `Delete ${count} leads?`} busy={busy} onClose={onClose}>
    <p className="mb-3 text-sm text-slate-700">{leadName ? `“${leadName}”` : `${count} selected lead${count === 1 ? "" : "s"}`} and associated CRM activities, workflow history and custom values will be permanently deleted. This cannot be undone.</p>
    <p className="mb-4 text-sm text-slate-500">Uploaded documents are retained in Documents without a lead assignment. The shared customer profile and records in other apps are retained.</p>
    <DocumentError message={error} />
    <div className="mt-5 flex justify-end gap-2">
      <button type="button" className={buttonClass} disabled={busy} onClick={onClose}>Cancel</button>
      <button type="button" className="crm-button crm-button-danger" disabled={busy} onClick={remove}>{busy ? "Deleting…" : count === 1 ? "Delete lead permanently" : `Delete ${count} leads permanently`}</button>
    </div>
  </DocumentDialog>;
}
